<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-input/listofTopics' }"
              >专题管理</el-breadcrumb-item
            >
            <el-breadcrumb-item>{{ this.isEdit ?'修改专题' : '新增专题' }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- <div class="zv-page-title">新增事件</div> -->
        <el-form
          ref="myForm"
          :model="formData"
          :rules="formRules"
          label-width="160px"
        >
          <el-form-item label="标题:" prop="title">
            <el-input
              class="el-input-width500"
              v-model="formData.title"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="专题类型:" prop="article_event_category_id">
            <el-select
                class="el-input-width1"
                v-model="formData.article_event_category_id"
                filterable
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.category_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="风险等级:" prop="risk_level">
            <el-select
                class="el-input-width1"
                v-model="formData.risk_level"
                filterable
              >
                <el-option
                  v-for="item in riskList"
                  :key="item.label"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="所属地区:" prop="area_id">
            <el-select
                class="el-input-width1"
                v-model="formData.area_id"
                filterable
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.full_area_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="详细地址:">
            <el-input
              class="el-textarea-width1"
              v-model="formData.address"
              type="textarea"
              :rows="3"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>

          <el-form-item label="浏览量:" prop="view_count">
            <el-input
              class="el-input-width1"
              v-model="formData.view_count"
            ></el-input>
          </el-form-item>

          <el-form-item label="文章来源:" prop="source">
            <el-input
              class="el-input-width1"
              v-model="formData.source"
            ></el-input>
          </el-form-item>

          <el-form-item label="事发时间:" prop="event_occurred_time">
            <el-date-picker
              class="el-input-width1"
              v-model="formData.event_occurred_time"
              type="datetime"
              placeholder="选择事发时间"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="死亡人数:" prop="death_num">
            <el-input
              class="el-input-width1"
              v-model="formData.death_num"
            ></el-input>
          </el-form-item>

          <el-form-item label="受伤人数:" prop="injured_num">
            <el-input
              class="el-input-width1"
              v-model="formData.injured_num"
            ></el-input>
          </el-form-item>

           <el-form-item label="华人死亡人数:" prop="chinese_death_num">
            <el-input
              class="el-input-width1"
              v-model="formData.chinese_death_num"
            ></el-input>
          </el-form-item>

          <el-form-item label="华人受伤人数:" prop="chinese_injured_num">
            <el-input
              class="el-input-width1"
              v-model="formData.chinese_injured_num"
            ></el-input>
          </el-form-item>

          <el-form-item label="事件主体:" prop="event_subject">
            <el-input
              class="el-input-width500"
              v-model="formData.event_subject"
            ></el-input>
          </el-form-item>

          <!-- @ready="onEditorReady($event)" -->
          <el-form-item label="趋势预测" prop="trend">
            <quill-editor v-model="formData.trend"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption">
            </quill-editor>
          </el-form-item>

          <el-form-item label="对中资企业及华人影响:" prop="affect_to_chinese">
            <el-input
              class="el-textarea-width1"
              v-model="formData.affect_to_chinese"
              type="textarea"
              :rows="3"
              placeholder="请输入影响"
            ></el-input>
          </el-form-item>


          <el-form-item label="请输入标签:" prop="tags">
            <el-input
              class="el-input-width500"
              v-model="formData.tags"
            ></el-input>
            <span style="margin-left: 10px;color: gray; font-size: 12px">*多个用逗号隔开（英文逗号）</span>
          </el-form-item>

          <!--  @ready="onEditorReady($event)" -->
          <el-form-item label="专题描述" prop="description">
            <quill-editor v-model="formData.description"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption">
            </quill-editor>
          </el-form-item>

          <el-form-item label="封面图片:">
              <img v-if="formData.cover" :src="formData.cover" style="width: 120px;height: 120px"/>
              <uploadFlie
                v-if="!formData.cover"
                ref="nationalFlag"
                imageType=".jpg,.jpeg,.png"
                :imageData="imageData"
                :imageUrl="imageUrl"
                :fileList="fileList1"
              ></uploadFlie>
              <el-button v-if="formData.cover" type="primary" @click="formData.cover='' ">编辑</el-button>
          </el-form-item>

          <el-form-item label="图片来源:" prop="cover_source">
            <el-input
              class="el-input-width1"
              v-model="formData.cover_source"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态:" prop="status">
            <el-radio-group v-model="formData.status">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="2">待审核</el-radio>
              <el-radio :label="0">删除</el-radio>
            </el-radio-group>
          </el-form-item>

          <div class="zv-flex-wrap" style="padding-top: 10px;">
            <div class="zv-form-item-label">关联文字:</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <div style="padding-bottom: 10px;">
                <el-button
                  type="primary"
                  size="mini"
                  >添加关联资讯</el-button
                >
              </div>
              <!-- <zv-table :table="selectedNewsTable" ref="snDataTable">
              </zv-table> -->
            </div>
          </div>
          <el-form-item label-width="auto" style="margin-left: 100px;margin-top: 20px">
            <el-button type="primary" @click="isEdit ? doSubmit(ids):doSubmit()">提交</el-button>
            <el-button @click="doCancel">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <zv-dialog
      width="700px"
      title="关联资讯"
      :showDialog.sync="showNewsTableDialog"
    >
      <div slot="content">
        <zv-table :table="dialogNewsTable" ref="dnDataTable" @on-selection-change="dialogNewsSelectChange">
        </zv-table>
      </div>
      <div slot="btns">
        <el-button @click="showNewsTableDialog = false">取消</el-button>
        <el-button type="primary" @click="confimAddRelatedNews"
          >确定</el-button
        >
      </div>
    </zv-dialog> -->
  </div>
</template>
<script>
import api from "./api";
import formPageMixin from "@/mixins/formPageMixin";
import TipUtil from "@/utils/utils/TipUtil";
import localData from "@/utils/utils/localData";
import { quillEditor } from 'vue-quill-editor' //调用编辑器
import uploadFlie from "@/components/unloadFile/index";
import tokenService from "@/utils/services/token_service"

export default {
  name: "CreateEvent",
  mixins: [formPageMixin],
  components: { uploadFlie,quillEditor },
  data() {
    let vm = this;
    return {
      ids: vm.$route.query.id,
      editorOption: {
        placeholder: '请输入趋势'
      },
      categoryList: '',
      areaList: '',
      isEdit: false,   // 是否为编辑
      riskList: [
        { label: '潜在风险'},
        { label: '轻微风险'},
        { label: '严重风险'},
        { label: '恶劣风险'},
        { label: '极度恶劣风险'}
      ],
      formData: {
        status: 1
      },
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "article_special_cover"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
      fileList1: [], //文件列表
      formRules: {
        title: [
          {
            required: true,
            message: "专题名不能为空",
            trigger: "blur"
          }
        ],
        area_id: {
          required: true,
          message: "所属地区不能为空",
          trigger: "change"
        },
        event_occurred_time: {
          required: true,
          message: "事发时间不能为空",
          trigger: "change"
        }
      },
    }
  },

  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },

  methods: {
    // categoryList列表
    async categoryListFn() {
      let res = await api.eventCategoryList()
      this.categoryList = res.list
    },
    // 所属地区下拉菜单
    async getAreaList() {
      this.areaList = await this.$commFunc.getAreaList({
        // area_type: 2
      });
    },

    async specialEditData() {
      let res = await api.articleSpecialInfo({
        id: this.$route.query.id
      })
      this.formData = res.info
      this.formData.event_occurred_time = this.formData.event_occurred_time*1000
      this.formData.tags = this.formData.tags_name
      this.fileList1.push({ url: this.formData.cover})
    },
    
    // 条件型 - 事件选择
    async conditionSelect(val) {
      // console.log(val)
      // console.log(this.formData)
      let selectAreaArr = this.formData.addressData
      if(selectAreaArr[0].address1) {
        let cityId = selectAreaArr[0].address1
        let countryId = this.getCountryIdByCity(cityId)
        let res = await api.getEventFieldOptionList({
          area_id: countryId,
          risk_id: val
        })
        
        this.eventRiskFieldOptions2 = res.list
        this.eventRiskFieldLists = res.field_list
      }
    },

   
    doCancel() {
      this.$router.back()
    },

    doSubmit(ids) {
      this.$refs.myForm.validate(async valid => {
        if (valid) {
          let msg
          if(this.formData.cover == "") {
            this.formData.cover = this.$refs.nationalFlag.UploadImageUrl;
          }
          // 处理时间戳过长
          if(this.formData.event_occurred_time) {
            if(this.formData.event_occurred_time.toString().length > 10) {
              this.formData.event_occurred_time = this.formData.event_occurred_time/1000
            }
          }
          if(ids) {
            this.formData.id = ids
            msg = "修改成功！"
            let res = await api.articleSpecialEdit(this.formData)
          }else {
            msg = "新增成功！"
            let res = await api.articleSpecialAdd(this.formData)
          }
          
          this.$message({
            message: msg,
            type: "success"
          });
          setTimeout(()=> {
            this.$router.push({
              name: "listofTopics"
            });
          },1000)
        }
      })
    } 
  },
  created() {
    if(this.$route.query.id) {
      this.isEdit = true
      this.specialEditData()
    }
    this.categoryListFn()
    this.getAreaList()
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.el-input-width500 {
  width: 500px !important;
}
.condition {
  .el-select {
    margin-right: 10px;
  }
}
.event-risk-wrap {
  padding: 10px 10px 18px;
}
.event-risk-inner {
  padding-bottom: 10px;
  border-bottom: 2px solid #ccc;
  font-size: 16px;
  line-height: 16px;
  display: inline-block;
}
</style>
<style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .ql-editor{
      height:200px;
    }
</style>
